import React from 'react';

import MP_profile from 'assets/team_photos/mp_profile.jpg';
import CD_profile from 'assets/team_photos/cd_profile.jpg';
import JB_profile from 'assets/team_photos/jb_profile.jpg';
import './styles.scss';


const jb_handle = 'JB_DogeBets';
const cd_handle = 'coreydeez';
const mp_handle = 'michael_pines';
const tgPrefix = 'https://t.me/';

function AboutUs(props) {
  return (<div className='AboutUs'>
    <p>DogeBets is a predictions gaming platform.</p>
    <p>Our core team consists of three members.</p>

    <div className='TeamMembers'>
      <div className='Member'>
        <img src={MP_profile} alt='MP' />
        <a href={tgPrefix + mp_handle} target='_blank' rel='noopener noreferrer'>@{mp_handle}</a>
      </div>
      <div className='Member'>
        <img src={JB_profile} alt='JB' />
        <a href={tgPrefix + jb_handle} target='_blank' rel='noopener noreferrer'>@{jb_handle}</a>
      </div>
      <div className='Member'>
        <img src={CD_profile} alt='CD' />
        <a href={tgPrefix + cd_handle} target='_blank' rel='noopener noreferrer'>@{cd_handle}</a>
      </div>
    </div>

    <p>We are also supported by a few mods & friends of the project across our communities.</p>
    <p>
      Our platform here at DogeBets.gg is the only official website.{' '}
      That includes live-events.dogebets.gg, our Live Events site.<br/>
      Currently <b>we do not have a token</b>
    </p>
  </div>);
}

export default AboutUs;